import React from "react";
import {
  Timeline,
  TextMsg,
  DocMsg,
  BotChat,
  AudioMsg,
  ImageMsg,
} from "../MessageTypes-component/MsgTypes";
import { Box, CircularProgress, Stack } from "@mui/material";
import { connect } from "react-redux";
import {
  setcontactlist,
  setMessage,
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
  endInteraction,
} from "../../../../Redux/Actions/actions";

const mapStateToProps = (state) => {
  return {
    chatspinner: state.data.chatspinner,
    loadmoreSpinner: state.data.loadmoreSpinner,
    customerTyping: state.data.customerTyping,
    externalChatData: state.contactListData.externalChatData,
    customerTypingId: state.contactListData.customerTypingId,
    message: state.chatReducer.message,
  };
};

const ConversationBodyInternal = (props) => {
  const { message, menu } = props;
  let selectedChat = JSON.parse(localStorage.getItem("client")) || {};

  return (
    <Stack spacing={1} sx={{ height: "100%", width: "100%" }}>
      {props.chatspinner && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {!props.chatspinner && (
        <>
          {message &&
            message.map((el, index) => {
              switch (el.msg_sent_type) {
                case "NOTIFICATIONS":
                  return <Timeline el={el} key={index} />;
                case "jpeg":
                case "png":
                case "IMAGE":
                  return <ImageMsg el={el} menu={menu} key={index} />;
                case "docx":
                  return (
                    <DocMsg
                      el={el}
                      menu={menu}
                      key={index}
                      type={"docx"}
                      size={"100px"}
                    />
                  );
                case "pdf":
                  return (
                    <DocMsg
                      el={el}
                      menu={menu}
                      key={index}
                      type={"pdf"}
                      size={"100px"}
                    />
                  );
                case "xlsx":
                  return (
                    <DocMsg
                      el={el}
                      menu={menu}
                      key={index}
                      type={"xlsx"}
                      size={"100px"}
                    />
                  );
                case "plain":
                  return (
                    <DocMsg
                      el={el}
                      menu={menu}
                      key={index}
                      type={"plain"}
                      size={"100px"}
                    />
                  );
                case "AUDIO":
                  return <AudioMsg el={el} menu={menu} key={index} />;
                case "mp4":
                case "VIDEO":
                  return <VideoMsg el={el} menu={menu} key={index} />;
                default:
                  return (
                    <TextMsg el={el} menu={menu} key={index} size={"400px"} />
                  );
              }
            })}
          {selectedChat.reciverDetails &&
          selectedChat.reciverDetails.length > 0 &&
          selectedChat.reciverDetails[0]._id === props.customerTypingId &&
          props.customerTyping ? (
            <BotChat />
          ) : selectedChat.senderDetails &&
            selectedChat.senderDetails.length > 0 &&
            selectedChat.senderDetails[0]._id === props.customerTypingId &&
            props.customerTyping ? (
            <BotChat />
          ) : (
            <></>
          )}
        </>
      )}
    </Stack>
  );
};

export default connect(mapStateToProps, {
  setcontactlist,
  setMessage,
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
  endInteraction,
})(ConversationBodyInternal);
